import React from "react";
import yaml from "js-yaml";

import { MyST } from "myst-to-react";
import { RendererContext } from "./alternatives.js";

export function Scenario(props) {
  const renderer = React.useContext(RendererContext);
  const ast = yaml.load(props.yaml);
  const sourceAST = {
    type: "root",
    children: [
      {
        type: "code",
        value: props.yaml.trim(),
        lang: "yaml",
      },
    ],
  };
  const renderAST = {
    type: "root",
    children: ast,
  };
  return (
    <div className="p-4 shadow-md">
      <h2 className="tracking-tight text-2xl font-medium ">{props.title}</h2>

      <h3 className="tracking-tight text-md font-semibold">AST</h3>
      <MyST ast={sourceAST} />

      <h3 className="tracking-tight text-md font-semibold">
        Preview ({renderer})
      </h3>
      <MyST ast={renderAST} />
    </div>
  );
}
